import { FC } from 'react'
import { Typography } from '@yanolja-org/ya-com-core'
import styled from '~/app/components/styled'
import BottomSheet from '~/app/components/common/BottomSheet/BottomSheet'
import { isoToFormat } from '~/app/utils/useIsoToFormat'
import { toKRW } from '~/app/utils/krNumberToString'
import { DomesticDailyPrices } from '~/__generated__/__types__'

/**
 * OrderPriceDetailsBottomsheet
 * 국내 숙소 연박 예약의 일자별 상세요금을 노출하는 BottomSheet
 */

type Props = {
  isOpened: boolean
  onRequestClose: () => void
  dailyPrices: DomesticDailyPrices[]
}

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding: 2rem 1.6rem 1.5rem;
`

const DailyList = styled.ul`
  display: flex;
  flex-direction: column;
`

const DailyRow = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 0;
  ${Typography('body1').regular};
  color: ${({ theme }) => theme.color.gray900};
`

const Divider = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: ${({ theme }) => theme.color.gray900};
`

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const TotalLabel = styled.span`
  ${Typography('subtitle3').bold};
  color: ${({ theme }) => theme.color.gray900};
`

const TotalPrice = styled.span`
  ${Typography('subtitle1').bold};
  color: ${({ theme }) => theme.color.gray900};
`

const OrderPriceDetailsBottomsheet: FC<Props> = function ({
  isOpened,
  onRequestClose,
  dailyPrices,
}) {
  const totalPrice = dailyPrices.reduce((sum, { price }) => sum + price, 0)

  return (
    <BottomSheet
      isOpened={isOpened}
      onRequestClose={onRequestClose}
      title={'상세 요금'}
      hideButtons
    >
      <Content>
        <DailyList>
          {dailyPrices.map(({ stayDate, price }) => (
            <DailyRow key={stayDate}>
              <span>{isoToFormat(stayDate, 'yyyy.MM.dd (ccc)')}</span>
              <span>{toKRW(price)}</span>
            </DailyRow>
          ))}
        </DailyList>
        <Divider />
        <TotalRow>
          <TotalLabel>총 요금</TotalLabel>
          <TotalPrice>{toKRW(totalPrice)}</TotalPrice>
        </TotalRow>
      </Content>
    </BottomSheet>
  )
}

export default OrderPriceDetailsBottomsheet
